import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LOAI_FORM, TT_PHIEU_KHO} from "types/enums";

export interface State {
  idPhieu: number | string;
  detailPhieu: any;
  typeForm: LOAI_FORM;
  statusPhieu: TT_PHIEU_KHO;
  khoKiemKeId: any;
}

const initialState: State = {
  idPhieu: null,
  detailPhieu: null,
  typeForm: null,
  statusPhieu: null,
  khoKiemKeId: null,
};

export const inventorySlice = createSlice({
  name: "inventory",
  initialState: initialState,
  reducers: {
    setIdPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, idPhieu: action.payload};
    },
    setKhoKiemKeId: (state = initialState, action: PayloadAction<any>) => {
      return {...state, khoKiemKeId: action.payload};
    },
    setTypeForm: (state = initialState, action: PayloadAction<any>) => {
      return {...state, typeForm: action.payload};
    },
    setStatusPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, statusPhieu: action.payload};
    },
    setDetailPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailPhieu: action.payload};
    },
  },
});

export const {
  setIdPhieu,
  setDetailPhieu,
  setKhoKiemKeId,
  setTypeForm,
  setStatusPhieu,
} = inventorySlice.actions;

export default inventorySlice.reducer;
